export default __webpack_public_path__ + "static/media/ordWhiteBackArrow.7be83311.svg";